import Controller from '../abstracts/Controller';
import 'scss-templates/t-editorial.scss';

export default class EditorialController extends Controller {
  static get COMPONENTS() {
    return [
      'CarouselComponent',
      'EditorialCoverInfiniteComponent',
      'JournalComponent',
      'LookbookComponent',
      'ManifestoComponent',
      'SocialComponent',
      'StoreEventComponent',
      'WishlistComponent',
      'FittingInformationComponent',
      'SeoTextComponent'
    ];
  }
}
